import { render } from "./LoadingPage.vue?vue&type=template&id=1a23d005&ts=true"
import script from "./LoadingPage.vue?vue&type=script&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&lang=ts"

import "./LoadingPage.vue?vue&type=style&index=0&id=1a23d005&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__